import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import Form from "../../../../components/common/form/Form";
import InputField from "../../../../components/common/form/InputField";
import SelectField from "../../../../components/common/form/SelectField";
import { createOptionListForSelectTag, isNullOrEmpty } from "../../../../helpers/utils/Utils";
import { OptionType } from "../../../../helpers/utils/StyleUtils";
import {
    useCreateConfigurationMutation,
    useDeleteCollectorConfigByIdServiceMutation,
    useGetCollectorConfigQuery
} from "../collector";
import { useParams } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import AddCronExp from "../modal/AddCronExp";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import ModalButton from "../../../../components/common/form/ModalButton";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import { IoIosArrowForward } from "react-icons/io";
import { ConfigurationTabDetail } from "./ConfigurationTabDetail";
import { handleRTKQuery } from "../../../../helpers/utils/RtkQueryUtils";

const Configuration = () => {
    let { collectorId } = useParams();
    const [collectorsData, setCollectorsData] = useState<any>({});
    const [updateSchedule, setUpdateSchedule] = useState("");
    const [showCronExpModal, setShowCronExpModal] = useState(false);
    const [updateCronIndex, setUpdateCronIndex] = useState(null);
    const [schedule, setSchedule] = useState("");
    const [configBtn, isConfigBtn] = useState(false);
    const { data: enums } = useGetEnumsQuery("");
    const { data: configData } = useGetCollectorConfigQuery(collectorId);
    const [toggleAccordion, setAccordion] = useState(false);
    const [isReadOnlyConfigPassword, setIsReadOnlyConfigPassword] = useState(false);

    const [configurationList, setConfigurationList] = useState<any[]>([])

    const [createConfigurationApi, createConfigurationpiResponse] = useCreateConfigurationMutation();
    const [deleteCollectorConfig, { isLoading }] = useDeleteCollectorConfigByIdServiceMutation();
    let conObj = {
        formatImplName: "",
        formatConfigArg: "",
    };
    const [fileConfigs, setFileConfigs] = useState([conObj]);
    const [showPackageDetail, setShowPackageDetail] = useState<boolean[]>(new Array(configurationList?.length).fill(false));
    const [showFileConfigTab, setShowFileConfigTab] = useState<boolean[]>(new Array(fileConfigs?.length).fill(false));
    const [isReadOnly, setIsReadOnly] = useState(hasPermission(["COLL-U"]) === false);

    const handleOnChange = (
        e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | null },
        index?: number // make index optional so it’s only needed when updating fileConfigs
    ) => {
        const { name, value } = "target" in e ? e.target : e;

        setCollectorsData((prevData: any) => ({
            ...prevData,
            [name]: value,
            ...(name === "state" ? { counties: [] } : {}),
        }));

        if ((name === "formatImplName" || name === "formatConfigArg") && typeof index === "number") {
            setFileConfigs((prevConfigs: any[]) => {
                const updated = [...prevConfigs];
                updated[index] = {
                    ...updated[index],
                    [name]: value,
                };
                return updated;
            });
        }

    };
    useEffect(() => {
        if (configData) {
            setConfigurationList(configData);
            setAccordion(true);
        }
    }, [configData]);

    const toggleShowPackageDetail = (index: number) => {
        const updatedShowPackageDetail = [...showPackageDetail];
        updatedShowPackageDetail[index] = isNullOrEmpty(updatedShowPackageDetail[index]) ? true : !updatedShowPackageDetail[index];
        setShowPackageDetail(updatedShowPackageDetail);
    }

    const toggleFileConfigTab = (index: number) => {
        const updatedShowPackageDetail = [...showFileConfigTab];
        updatedShowPackageDetail[index] = isNullOrEmpty(updatedShowPackageDetail[index]) ? true : !updatedShowPackageDetail[index];
        setShowFileConfigTab(updatedShowPackageDetail);
    }
    const handleDelete = async (configId: string) => {
        if (configId) {
            await deleteCollectorConfig(configId).unwrap();
        }
    };
    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const requestBody = {
            ...collectorsData,
            schedule: schedule.toString().slice(0, -1),
            dataFileType: collectorsData.dataFileType?.value,
            collector: {
                id: collectorId,
            },
            fileConfigurations: collectorsData?.fileConfigurations,
        };

        await handleRTKQuery(
            async () => {
                const response = await createConfigurationApi({
                    requestBody,
                    isSendLink: false,
                }).unwrap();

                return response;
            },
            (response: any) => {
                if (response?.success) {
                    setCollectorsData({});
                    setFileConfigs([conObj]);
                    setSchedule("");
                }
            }
        );
    };



    const handleAddFileConfigType = () => {
        const { formatImplName, formatConfigArg } = fileConfigs[0];

        if (!formatImplName && !formatConfigArg) return;

        setCollectorsData((prev: any) => ({
            ...prev,
            fileConfigurations: [
                ...(prev.fileConfigurations || []),
                {
                    formatImplName,
                    formatConfigArg,
                },
            ],
        }));

        const newTaxRate = {
            formatImplName: "",
            formatConfigArg: "",
        };
        setFileConfigs((prev: any) => [newTaxRate, ...prev]);
    };

    const handleRemoveFileConfigTab = (index: number) => {
        const updatedList = [...fileConfigs];
        updatedList.splice(index, 1);
        setFileConfigs(updatedList);
    };

    const handleCancel = () => {
        setCollectorsData({});
        setFileConfigs([conObj]);
        setSchedule("");
    };
    const handleToggle = (property: string) => () => {
        setCollectorsData((prevData: any) => ({
            ...prevData,
            [property]: !prevData[property]
        }));
    };

    const handleFormatImplNameChange = (value: string) => {
        setFileConfigs([{ ...fileConfigs[0], formatImplName: value }]);
    };

    const handleFormatConfigArgChange = (value: string) => {
        setFileConfigs([{ ...fileConfigs[0], formatConfigArg: value }]);
    };

    return (
        <>
            {hasPermission(["DATARETVAL-V", "DATARETVAL-R"], true) &&
                <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm rounded-md mt-2">
                    <div className="flex justify-between items-center border-b bordder border-surface-7 p-2">
                        <h5 className="font-semibold text-surface-0">Configuration</h5>
                    </div>

                    <div className={'p-2'}>
                        {hasPermission(["DATARETVAL-C"]) &&
                            <Form
                                onSubmit={handleSubmit}
                                fields={
                                    <>
                                        <InputField name="url"
                                            label="Url" value={collectorsData?.url || ""}
                                            onChange={handleOnChange}
                                            required
                                            placeholder="Enter Url..." />

                                        <InputField
                                            name="username"
                                            label="User Name"
                                            value={collectorsData?.username || ""}
                                            onChange={handleOnChange}
                                            placeholder="Enter User Name..." />

                                        <InputField
                                            name="password"
                                            label="Password"
                                            value={collectorsData?.password || ""}
                                            onChange={handleOnChange}
                                            placeholder="Enter Password..."
                                            disabled={isReadOnlyConfigPassword && collectorsData.password}
                                        />


                                        <SelectField
                                            placeholder="Select Data File Type..."
                                            value={collectorsData?.dataFileType || null}
                                            options={createOptionListForSelectTag(enums?.["DataFileType"], "value", "constant")}
                                            onChange={(selectedOption) => handleOnChange({ name: "dataFileType", value: selectedOption })}
                                            label="Data File Type"
                                            required />

                                        <div className="col-span-12 grid grid-cols-12 gap-3">
                                            <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                                <label className="min-w-[100px]">*Schedule</label>
                                            </div>

                                            <div className="relative col-span-9 flex items-center gap-3">
                                                <div className="w-full">
                                                    <InputField
                                                        placeholder="Schedule..."
                                                        type="text"
                                                        name="Schedule"
                                                        value={schedule}
                                                        hideLabel={true}
                                                        disabled={true}

                                                    />
                                                </div>
                                                {!isReadOnly &&
                                                    <i
                                                        onClick={() => {
                                                            setShowCronExpModal(true);
                                                            setUpdateCronIndex(null);
                                                            setSchedule("Hourly")
                                                        }}
                                                        className="fa fa-plus-circle text-md mt-2 cursor-pointer text-highlight-0"
                                                        title="Add Schedule"
                                                    ></i>}
                                            </div>
                                        </div>
                                        <InputField
                                            name="retrieverImplName"
                                            label="Retriever Name"
                                            value={collectorsData?.retrieverImplName || ""}
                                            onChange={handleOnChange}
                                            placeholder="Retriever Name..." />
                                        <InputField
                                            name="retrieverArg"
                                            label="Retriever Args"
                                            value={collectorsData?.retrieverArg || ""}
                                            onChange={handleOnChange}
                                            placeholder="Retriever Args..." />
                                        <InputField
                                            name="mapperImplName"
                                            label="Mapper Name"
                                            value={collectorsData?.mapperImplName || ""}
                                            onChange={handleOnChange}
                                            placeholder="Mapper Name..."
                                            required />

                                        <InputField
                                            name="mapperConfigArg"
                                            label="Mapper Args"
                                            value={collectorsData?.mapperConfigArg || ""}
                                            onChange={handleOnChange}
                                            placeholder="Mapper Args..." />

                                        <InputField
                                            name="persistenceImplName"
                                            label="Persist Name"
                                            value={collectorsData?.persistenceImplName || ""}
                                            onChange={handleOnChange}
                                            placeholder="Persist Name..."
                                            required />

                                        <InputField
                                            name="persistenceConfigArg"
                                            label="Persist Args"
                                            value={collectorsData?.persistenceConfigArg || ""}
                                            onChange={handleOnChange}
                                            placeholder="Persist Args..." />
                                        <InputField
                                            name="enabled"
                                            label="Enabled"
                                            type="checkbox"
                                            checked={collectorsData?.enabled}
                                            onChange={handleToggle("enabled")} />

                                        <div className="col-span-12 grid grid-cols-12 gap-3">
                                            <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                                <label className="min-w-[100px]">*File Config</label>
                                            </div>

                                            <div className="relative col-span-9 flex flex-col gap-3">
                                                {fileConfigs?.map((curPerson: any, index: number) => (
                                                    <div key={index} className="flex gap-2 items-start">

                                                        {/* Config Block */}
                                                        <div className="w-full">
                                                            <div className={`md:grid md:grid-cols-12 ${index === 0 ? "mt-3" : "mt-0"} gap-2`}>
                                                                <div className="col-span-12 mb-1 border border-surface-5">

                                                                    {/* Header */}
                                                                    <div
                                                                        className="flex justify-between px-2 py-2 bg-surface-5 cursor-pointer items-center"
                                                                        onClick={() => toggleFileConfigTab(index)}
                                                                    >
                                                                        <div className="flex gap-1 items-center">
                                                                            <h3>{curPerson?.formatImplName || "No Format Name"}</h3>
                                                                        </div>
                                                                        <div className="flex gap-3 items-center">
                                                                            <IoIosArrowForward
                                                                                className={`text-lg transition-transform duration-200 ${showFileConfigTab[index] ? "rotate-90" : ""}`}
                                                                            />
                                                                            {fileConfigs.length >= 2 && index !== 0 && (
                                                                                <FaTrash
                                                                                    className="cursor-pointer text-highlight-0"
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation(); // Prevent toggling
                                                                                        handleRemoveFileConfigTab(index);
                                                                                    }}
                                                                                    title="Delete Config"
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    {/* Expandable Body */}
                                                                    {showFileConfigTab[index] && (
                                                                        <div className="w-full p-4 flex flex-col gap-3">
                                                                            <InputField
                                                                                placeholder="Enter Format Name"
                                                                                label="Format Name"
                                                                                name="formatImplName"
                                                                                onChange={(e) => handleFormatImplNameChange(e.target.value)}
                                                                                value={curPerson?.formatImplName || ""}
                                                                            />
                                                                            <InputField
                                                                                placeholder="Enter Format Args"
                                                                                label="Format Args"
                                                                                name="formatConfigArg"
                                                                                onChange={(e) => handleFormatConfigArgChange(e.target.value)}
                                                                                value={curPerson?.formatConfigArg || ""}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Add Button aligned in second column */}
                                                        {!isReadOnly &&
                                                            <div className="w-[32px] flex justify-center pt-4">
                                                                {index === 0 ? (
                                                                    <i
                                                                        className="fa fa-plus-circle text-black cursor-pointer text-highlight-0 mt-2"
                                                                        title="Add File Config"
                                                                        onClick={handleAddFileConfigType}
                                                                    ></i>
                                                                ) : (
                                                                    <div className="w-[24px]" /> // placeholder for alignment
                                                                )}
                                                            </div>
                                                        }
                                                    </div>
                                                ))}
                                            </div>
                                        </div>





                                        {!isReadOnly &&
                                            < div className="col-span-12 md:grid md:grid-cols-12 gap-3" >
                                                <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                                </div>
                                                <div className="relative col-span-9">
                                                    <div className={"mt-4 flex"}>
                                                        <ButtonTray buttons={[
                                                            {
                                                                buttonProps: {
                                                                    btnText: "Cancel",
                                                                    onClick: handleCancel,
                                                                    type: "close"
                                                                },
                                                                buttonType: "button"
                                                            },
                                                            {
                                                                buttonProps: {
                                                                    btnText: "Add",
                                                                    type: "submit",
                                                                    isLoading: (createConfigurationpiResponse.isLoading),
                                                                },
                                                                buttonType: "button"
                                                            }
                                                        ]} align="center" gap={2} />
                                                    </div>
                                                </div>
                                            </div>}



                                        {
                                            showCronExpModal &&
                                            <AddCronExp show={showCronExpModal} setShow={setShowCronExpModal}
                                                schedule={schedule}
                                                setSchedule={setSchedule} isConfigBtn={isConfigBtn}
                                                updateCronIndex={updateCronIndex}
                                                updateSchedule={updateSchedule}
                                                setUpdateSchedule={setUpdateSchedule}
                                            />
                                        }
                                    </>
                                }
                            />}
                        {
                            toggleAccordion &&
                            configurationList?.map((curPerson: any, index: number) => (
                                <div className={`col-span-12 md:grid md:grid-cols-12 ${index === 0 && "mt-3"}`}
                                    key={index}>

                                    <div className="bg-highlight-0  col-span-12 mb-1">
                                        <div className="justify-between flex px-2  cursor-pointer items-center"
                                            onClick={() => {
                                                toggleShowPackageDetail(index);
                                            }}>
                                            <div className="flex gap-1 items-center">
                                                <h3 className="text-text-0 font-semibold px-1 py-2">{curPerson?.dataFileType}</h3>
                                            </div>
                                            <div className="flex gap-3">
                                                <IoIosArrowForward
                                                    className={"text-text-0 text-lg cursor-pointer " + (showPackageDetail[index] ? "rotate-90" : "")}

                                                />
                                                {hasPermission(["DATARETVAL-D"]) &&
                                                    <ModalButton
                                                        triggerButton={<FaTrash
                                                            className={"cursor-pointer text-lg hover:text-text-hover-1 text-text-1"}
                                                            title={"Delete Person Info"} />}
                                                        onOpen={() => {
                                                        }}
                                                        modal={
                                                            <ConfirmationModal
                                                                show={true}
                                                                setShow={() => {
                                                                }}
                                                                title={"Delete Collector Config"}
                                                                bodyMessage={"Are you sure you want to delete this Collector Config?"}
                                                                onSubmit={() => handleDelete(curPerson?.id)}
                                                                isLoading={isLoading}
                                                            />
                                                        }
                                                    />}
                                            </div>
                                        </div>
                                        {
                                            showPackageDetail[index] &&
                                            <div className="col-span-9 p-3 bg-text-0">
                                                <ConfigurationTabDetail
                                                    enums={enums}
                                                    submitBtnText="Save"
                                                    obj={curPerson}
                                                    index={index}
                                                    isReadOnly={!hasPermission(["DATARETVAL-U"])}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                            ))}</div>
                </div>
            }

        </>
    );
};

export default Configuration;
